import {node_observable_component} from 'common/util/ComponentDecorator';
import './our-projects.scss';
import galleryService from 'common/util/galleryService';

@node_observable_component
export default class OurProjects {
	static classname = 'our-projects';

	constructor(projects) {
		this.bindEventListeners();
	}

	bindEventListeners = () => {
		galleryService.onListOpen('.our-projects__item', '.our-projects__list', '.our-projects__item-img', 'data-zoom');
	};

};
